import React, { useState } from 'react';
import { Button } from '../../Button';
import { Card } from '../../Card';
import { Popover } from '../../Popover';
import { Stack } from '../../Stack';
import { theme } from '../../../theme';
import { VisiblityIcon } from '../../../tempIcons/VisibilityIcon';
import { VisiblityOffIcon } from '../../../tempIcons/VisibilityOffIcon';
import { ReorderIcon } from '../../../tempIcons/ReorderIcon';
export function ColumnMenu({ columns, columnGroups, setColumns }) {
    const [popoverAnchor, setPopoverAnchor] = useState(null);
    const [showPopover, setShowPopover] = useState(false);
    const columnEntries = columns.map((column) => [column.id, column]);
    const columnsMap = Object.fromEntries(columnEntries);
    const groups = columnGroups.map((group) => group.map((columnId) => columnsMap[columnId]));
    const setHidden = (groupIndex, hidden) => {
        const columnIds = groups[groupIndex].map((column) => column.id);
        const newColumns = [...columns];
        columnIds.forEach((columnId) => {
            const index = newColumns.findIndex((column) => column.id === columnId);
            if (index < 0)
                return;
            newColumns[index] = Object.assign(Object.assign({}, newColumns[index]), { hidden });
        });
        setColumns(newColumns);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { ref: setPopoverAnchor, dropdown: true, onClick: () => setShowPopover(true) }, "Columns"),
        showPopover && (React.createElement(Popover, { anchorElement: popoverAnchor, onShouldClose: () => setShowPopover(false) },
            React.createElement(Card, { style: { width: 600 } },
                React.createElement(Stack, { alignX: "stretch", spacing: "sm" }, groups.map((group, groupIndex) => (React.createElement(Stack, { key: group[0].id, direction: "horizontal", alignY: "center", spacing: "sm", style: {
                        border: '1px solid black',
                        padding: 8,
                    } },
                    React.createElement(Button, { variant: "flat", icon: React.createElement(ReorderIcon, null) }),
                    React.createElement(Stack, { spacing: "sm", style: { flex: 1 } }, group.map((column) => (React.createElement("div", { key: column.id }, column.title)))),
                    React.createElement(Stack, { direction: "horizontal", spacing: "sm" }, group[0].hidden ? (React.createElement(Button, { variant: "flat", icon: React.createElement(VisiblityOffIcon, null), onClick: () => setHidden(groupIndex, false), style: { color: theme.colors.neutral.ink.lightest } })) : (React.createElement(Button, { variant: "flat", icon: React.createElement(VisiblityIcon, null), onClick: () => setHidden(groupIndex, true) }))))))))))));
}
//# sourceMappingURL=ColumnMenu.js.map